module.exports = __webpack_public_path__ + "img/FTC-alt.87485808.svg";